export const fileUploadConsts = {
    UPLOAD_FILE: "UPLOAD_FILE"
};
